import { Type } from "@angular/core";
import { GridViewComponent } from './grid-view.component';

export * from "./grid-view.component";

export const HBR_GRIDVIEW_DIRECTIVES: Type<any>[] = [
    GridViewComponent
];
